import React from 'react';
import { Link } from 'react-router-dom';
import { AiFillLinkedin, } from "react-icons/ai";
import { AiFillYoutube } from "react-icons/ai";
import { AiFillFacebook } from "react-icons/ai";
import { AiFillInstagram } from "react-icons/ai";

import Newsletter from '../../BecomeACounselor/Newsletter';
import OfficeLocation from '../../ContactUs/OfficeLocation';


export default function Footer() {
    return (
        <div>
            <OfficeLocation />
            <Newsletter />
            <footer className="footer grid-col-2 p-20 bg-sky-900 text-neutral-content">
                <div>
                    <span className="footer-title">BTech</span>
                    <a className="link link-hover">Top Engineering Colleges</a>
                    <a className="link link-hover">Top Coaching institutes</a>
                    <a className="link link-hover">Popular Exams for Btech</a>
                    <a className="link link-hover">Comparison between colleges</a>
                    <a className="link link-hover">Top engineering colleges in UP</a>
                </div>
                <div>
                    <span className="footer-title">Medical</span>
                    <a className="link link-hover">Top Medical Colleges</a>
                    <a className="link link-hover">Top Coaching institutes</a>
                    <a className="link link-hover">Popular Exams for Medical</a>
                    <a className="link link-hover">Comparison between colleges</a>
                    <a className="link link-hover">Top Medical colleges in UP</a>
                </div>
                <div>
                    <span className="footer-title">MBA</span>
                    <a className="link link-hover">Top MBA Colleges</a>
                    <a className="link link-hover">Top Coaching institutes</a>
                    <a className="link link-hover">Popular Exams for MBA</a>
                    <a className="link link-hover">Comparison between colleges</a>
                    <a className="link link-hover">Top MBA colleges in UP</a>
                </div>
                <div>
                    <span className="footer-title">About Us</span>
                    <Link to='/about-us' className="link link-hover">About Us</Link>
                    <Link to='/' className="link link-hover">Home</Link>
                    <Link to='/contact-us' className="link link-hover">Contact Us</Link>
                    <Link to='/counselor' className="link link-hover">Become a counselor</Link>
                    <a className="link link-hover">Blogs</a>
                </div>
                <div>
                    <span className="footer-title">Legal</span>
                    <Link to='/terms-and-conditions' className="link link-hover">Terms & Conditions</Link>
                    <Link to='/privacy-policy' className="link link-hover">Privacy Policy</Link>
                    <Link to='/cookie-policy' className="link link-hover">Cookie Policy</Link>
                    <Link to='/refund-policy' className="link link-hover">Refund Policy</Link>
                    <Link to='/takedown-policy' className="link link-hover">Takedown policy</Link>
                </div>
                <div>
                    <span className="footer-title">Social</span>
                    <div className='flex'>

                        <a className="link link-hover mr-5"><AiFillInstagram size={30} onMouseOver={({ target }) => target.style.color = "#fff"}
                            onMouseOut={({ target }) => target.style.color = "#d1d5db"} /></a>
                        <a className="link link-hover mr-5"><AiFillFacebook size={30} onMouseOver={({ target }) => target.style.color = "#fff"}
                            onMouseOut={({ target }) => target.style.color = "#d1d5db"} /></a>
                        <a className="link link-hover mr-5"><AiFillYoutube size={30} onMouseOver={({ target }) => target.style.color = "#fff"}
                            onMouseOut={({ target }) => target.style.color = "#d1d5db"} /></a>
                        <a className="link link-hover mr-5"><AiFillLinkedin size={30} onMouseOver={({ target }) => target.style.color = "#fff"}
                            onMouseOut={({ target }) => target.style.color = "#d1d5db"} /></a>
                    </div>
                </div>

            </footer>
        </div>

    );
}










